
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits.dispatchEvent('Flits:AccountPage:Visible')
  Flits(document).on('Flits:AccountPage:Visible',function() {
    Flits('[href="/account/logout"]').attr('data-no-instant','')
  })
  Flits(document).on('click', '.flits-reorder-custom-btn', (function() {
    let el = Flits(this);
    let quantity = 1;
    let maxLimit = Flits(el).attr("data-flits-max");;
    let id = Flits(el).attr("data-flits-variant-id");
    let interval = 0;
    if (cartOrder[id]) {
      if (quantity + parseInt(cartOrder[id].cart_quantity) > maxLimit) {
          quantity = maxLimit - parseInt(cartOrder[id].cart_quantity);
          quantity == 0 ? quantity = maxLimit : quantity;
          interval = 3000;
          flitsSnackbar.show({
              text: Flits.t('Flits.locals.general.cart_updated', 'Some items are no longer available. Your cart has been updated.'),
              pos: 'bottom-center',
              showAction: false,
              customClass: 'flits-alert-default'
          })
      }
    }
    let data = "id=" + id + "&quantity=" + quantity;
    setTimeout((function() {
      Flits.addToCart(data)
    }
    ), interval)
    }));
}(Flits));
